import { logoProxyLoader } from '@repo/utils'
import { getImageProps } from 'next/image'

/**
 * `<img>` props for a `toLogoSrc` path drawn at `px` CSS pixels, with 1x, 2x
 * and 3x candidates at exactly that size. next/image only emits 1x/2x, so
 * covering 3× (phone) screens meant requesting an oversized image the browser
 * then shrank, which blurs logos. Widths missing from `images.imageSizes` snap
 * up to the next configured one.
 */
export function getLogoProxyImgProps(src: string, px: number, alt = '') {
  const base = { src, alt, loader: logoProxyLoader }
  const { props } = getImageProps({ ...base, width: px, height: px })
  // The 1x candidate of a 3× request, not its `src` (which is that request's 2x).
  const x3 = getImageProps({ ...base, width: px * 3, height: px * 3 }).props.srcSet?.split(' ')[0]
  return { ...props, srcSet: x3 ? `${props.srcSet}, ${x3} 3x` : props.srcSet }
}
